import { Link } from 'react-router-dom';
import { allCategories } from '@/utils/article';

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-fire-line" />
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">黑料网曝大瓜</span>
            </div>
            <p className="text-sm text-primary-100/70 leading-relaxed max-w-md">
              全网最快、最全的明星八卦与娱乐爆料资讯平台。聚焦明星绯闻、最新娱乐动态、热门爆料与专题合集，让你第一时间吃上最新鲜的瓜。
            </p>
            <p className="mt-4 text-xs text-primary-100/50">
              本站内容均为虚构演示示例，仅用于产品设计展示，不涉及任何真实人物与事件。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {allCategories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-primary-100/70 hover:text-secondary-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">快捷入口</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-primary-100/70 hover:text-secondary-400 transition-colors">首页</Link></li>
              <li><Link to="/search" className="text-sm text-primary-100/70 hover:text-secondary-400 transition-colors">搜索大瓜</Link></li>
              <li><Link to="/about" className="text-sm text-primary-100/70 hover:text-secondary-400 transition-colors">关于我们</Link></li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-tiktok-fill', 'ri-mail-line'].map((icon) => (
                <span key={icon} className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-900 text-primary-100/80 hover:text-secondary-400 transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/50">© 2026 黑料网曝大瓜 · 娱乐八卦资讯平台 · 演示站点</p>
          <div className="flex items-center gap-4 text-xs text-primary-100/50">
            <span>联系邮箱：contact@gossip-demo.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}